const text = {
  premix: {
    title: 'Manufacturer-prepared (not compounding facility) premixed IV solutions and parenteral nutrition solutions',
    subtext: '* This list is a representative sample and is not intended to be a complete list of all manufacturer-prepared injectable medications.',
  },
  syringes: {
    title: 'Manufacturer-prepared (not compounding facility) prefilled medication syringes',
    subtext: '* This list is a representative sample and is not intended to be a complete list of all manufacturer-prepared injectable medications.',
  },
  compounding: {
    title: 'IV admixtures available from 503B compounding facilities',
    subtext: '* This list is a representative sample and is not intended to be a complete list of all injectable medications available from compounding facilities.',
  },
};

const lists = {
  premix: [
    'Aminodarone',
    'Ampicillin',
    'Ampicillin/sulbactam',
    'Argatroban',
    'Aztreonam',
    'Cefazolin',
    'Ceftazidime',
    'Ceftriaxone',
    'Ciprofloxacin',
    'Clindamycin',
    'Dobutamine',
    'Dopamine',
    'Esmolol',
    'Gentamicin infusion (various strengths)',
    'Heparin 25,000 unites/250 mL infusion (or other strengths of bags)',
    'Imipenem/cilastatin',
    'Levitiracitam',
    'Levofloxacin',
    'Lidocaine',
    'Linezolid',
    'Magnesium sulfate',
    'Mannitol',
    'Meropenem',
    'Metronidazole',
    'Milrinone',
    'Nafcillin',
    'Nitroglycerin',
    'Ondansetron',
    'Oxytocin',
    'Penicillin G',
    'Piperacillin/tazobactam',
    'Potassium chloride in 50 mL, 100 mL, or other admixed strengths',
    'Potassium chloride in Sodium Chloride or Dextrose in Water (various strengths)',
    'Vancomycin',
    'Zolendronic acid',
  ],
  syringes: [
    {
      heading: 'Anticoagulants',
      contents: [
        'Enoxaparin (PFS)',
        'Heparin (PFS)',
      ],
    }, {
      heading: 'Cardiac Agents',
      contents: [
        'Labetalol (PFS)',
        'Metoprolol (PFS)',
      ],
    }, {
      heading: 'Emergency Syringes',
      contents: [
        '50% Dextrose (PFS)',
        'Atropine Sulfate (PFS)',
        'Calcium Chloride (PFS)',
        'Epinephrine (PFS)',
        'Etomidate (PFS)',
        'Lidocaine (PFS)',
        'Sodium Bicarbonate (PFS)',
      ],
    }, {
      heading: 'Opioids',
      contents: [
        'Fentanyl (PFS)',
        'Hydromorphone (PFS)',
        'Meperidine (PFS)',
        'Morphine (PFS)',
      ],
    }, {
      heading: 'Sedation Agents',
      contents: [
        'Diazepam (PFS)',
        'Lorazepam (PFS)',
        'Midazolam (PFS)',
      ],
    }, {
      heading: 'Reversal Agents',
      contents: [
        'Naloxone (PFS)',
      ],
    }, {
      heading: 'Miscellaneous',
      contents: [
        'Dexamethasone (PFS)',
        'Diphenhydramine (PFS)',
        'Ketorolac (PFS)',
        'Metoclopramide (PFS)',
        'Ondansetron (PFS)',
        'Palonosetron (PFS)',
      ],
    }, {
      heading: 'Vaccines',
      contents: [
        'Hepatitis B',
        'Influenza',
        'Dtap, Tdap',
      ],
    },
  ],
  compounding: [
    'Adenosine syringe',
    'Amiodarone IV',
    'Atropine syringe',
    'Bupivacaine IV',
    'Bupivacaine syringe',
    'Bupivacaine cassette',
    'Bupivacaine elastomeric pump',
    'Calcium chloride IV',
    'Calcium gluconate IV',
    'Calcium gluconate syringe',
    'Cefazolin IV',
    'Cefazolin syringe',
    'Cisatracurium syringe',
    'Dexamethasone IV',
    'Dexamethasone syringe',
    'Diltiazem IV',
    'Diphenhydramine IV',
    'Ephedrine syringe',
    'Epinephrine IV',
    'Epinephrine syringe',
    'Esmolol syringe',
    'Famotidine syringe',
    'Fentanyl IV',
    'Fentanyl syringe',
    'Fentanyl PCA cartridge/vial',
    'Fentanyl cassette',
    'Fentanyl/Bupivacaine IV',
    'Fentanyl/Bupivacaine syringe',
    'Fentanyl/Bupivacaine cassette',
    'Fentanyl/Ropivacaine IV',
    'Fentanyl/Ropivacaine syringe',
    'Fentanyl/Ropivacaine cassette',
    'Furosemide IV',
    'Glycopyrrolate syringe',
    'Heparin IV',
    'Heparin syringe',
    'Hydromorphone IV',
    'Hydromorphone syringe',
    'Hydromorphone PCA cartridge/vial',
    'Hydromorphone cassette',
    'Hydromorphone/Ropivacaine',
    'Ketamine syringe',
    'Labetolol IV',
    'Labetolol syringe',
    'Lidocaine IV',
    'Lidocaine syringe',
    'Lidocaine cassette',
    'Lorazepam IV',
    'Magnesium Sulfate IV',
    'Meperidine IV',
    'Meperidine syringe',
    'Meperidine PCA vial',
    'Meperidine cassette',
    'Methadone IV',
    'Methadone syringe',
    'Methohexital syringe',
    'Metoprolol syringe',
    'Midazolam IV',
    'Midazolam syringe',
    'Midazolam PCA vial',
    'Midazolam cassette',
    'Morphine IV',
    'Morphine syringe',
    'Morphine cassette',
    'Morphine/Bupivacaine IV',
    'Morphine/Bupivacaine syringe',
    'Morphine/Bupivacaine cassette',
    'Neostigmine syringe',
    'Nicardipine IV',
    'Nicardipine syringe',
    'Norepinephrine IV',
    'Norepinephrine syringe',
    'Ondansetron IV',
    'Oxytocin IV',
    'Phenylephrine IV',
    'Phenylephrine syringe',
    'Potassium acetate IV',
    'Potassium chloride IV',
    'Potassium phosphate IV',
    'Propofol syringe',
    'Remifentanil syringe',
    'Rocuronium syringe',
    'Ropivacaine IV',
    'Ropivacaine syringe',
    'Ropivacaine elastomeric pump',
    'Ropivacaine cassette',
    'Sodium Bicarbonate IV',
    'Sodium citrate syringe',
    'Sodium phosphate IV',
    'Succinylcholine syringe',
    'Sufentanil/Bupivacaine IV',
    'Sufentanil/Bupivacaine syringe',
    'Sufentanil/Bupivacaine cassette',
    'Sufentanil/Ropivacaine IV',
    'Sufentanil/Ropivacaine cassette',
    'Tromethamine syringe',
    'Trophamine/Dextrose/Calcium gluconate',
    'Vancomycin IV',
    'Vasopressin IV',
    'Vecuronium IV',
    'Vecuronium syringe',
  ],
};

export default { text, lists };



// WEBPACK FOOTER //
// ./src/components/features/assessment/MedicationListModalData.js